import "./summary-view.js";
import "./received-order.js";
import "./inbound-dashboard.js";
import "./product-by-inventory.js";


// WEBPACK FOOTER //
// ./src/pages/dashboard/index.js